import { TColors } from '@cian/ui-kit-design-tokens/colors';

import { ELabelType } from '../types/newbuildingHeader';

export const BACKGROUND_COLOR: Record<ELabelType, TColors> = {
  [ELabelType.Reliable]: 'control-positive-secondary-default',
  [ELabelType.Problem]: 'accent-negative-primary',
  [ELabelType.SalesLeader]: 'accent-ghost-secondary',
};

export const TEXT_COLOR: Record<ELabelType, TColors> = {
  [ELabelType.Reliable]: 'text-positive-pressed',
  [ELabelType.Problem]: 'theme-white',
  [ELabelType.SalesLeader]: 'theme-dark',
};

export const ICON = {
  [ELabelType.Reliable]: undefined,
  [ELabelType.Problem]: undefined,
  [ELabelType.SalesLeader]: undefined,
};
